let { patchQuery } = require('../../helpers/utils');

module.exports = function (location, params) {
    return patchQuery(location, params);
}



// WEBPACK FOOTER //
// ./services/helpers/patchQuery.js